import { Badge, cn } from 'shared-ui';

import type { StatusPillPresentation } from './statusPillPresentation';

/**
 * The status pill used on the POI/leak hover cards and details panels, the Network
 * Overview table's Assessment Result, and the van details panel. Colours are inline from
 * the presentation (sourced from the marker registry via statusPillPresentation) so pills
 * and markers can never drift apart.
 */
export function StatusPill({ presentation, className }: { presentation: StatusPillPresentation; className?: string }) {
    const Icon = presentation.icon;
    return (
        <Badge
            className={cn(
                'inline-flex h-[22px] w-fit items-center gap-1 rounded-[10px] px-2.5 text-xs leading-4 font-medium tracking-normal',
                presentation.neutral && 'border-border bg-background text-muted-foreground',
                className,
            )}
            style={
                presentation.neutral
                    ? undefined
                    : { backgroundColor: presentation.background, color: presentation.color }
            }
            aria-label={`Status: ${presentation.label}`}
        >
            <Icon className="shrink-0" aria-hidden="true" />
            {presentation.label}
        </Badge>
    );
}
